// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Fo5l","buttons":"SendReceipts_buttons__2AGaU","email":"SendReceipts_email__17nzz","bookApptTitle":"SendReceipts_bookApptTitle__1kbZq"};